import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class WorkFilesService {
  constructor(private apiService: ApiService) {}

  uploadWorkNotificationFile(avisFile: File) {
    const formData = new FormData();
    formData.append('file', avisFile);
    return this.apiService.post(
      '/WorkFiles/WorkNotificationFileUpload',
      formData
    );
  }

  uploadWorkOrderFile(ordresFile: File) {
    const formData = new FormData();
    formData.append('file', ordresFile);
    return this.apiService.post('/WorkFiles/WorkOrderFileUpload', formData);
  }

  uploadWorkOrderOperationsFile(operationsFile: File) {
    const formData = new FormData();
    formData.append('file', operationsFile);
    return this.apiService.post('/WorkFiles/WorkOrderOperationsFileUpload', formData);
  }
}
